"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeClientId = exports.setClientId = exports.getClientId = exports.setHistoryDidMigrate = exports.getHistoryDidMigrate = exports.setHistoryLegacy = exports.getHistoryLegacy = exports.removeHistory = exports.setHistory = exports.getHistory = exports.removeBenchmarkResult = exports.setBenchmarkResult = exports.getBenchmarkResult = exports.clearStorage = void 0;
var prefix = "";
var VolatileStorage = /** @class */ (function () {
    function VolatileStorage() {
        this.data = new Map();
    }
    VolatileStorage.prototype.getItem = function (key) {
        var r = this.data.get(key);
        return r === undefined ? null : r;
    };
    VolatileStorage.prototype.setItem = function (key, value) {
        this.data.set(key, value);
    };
    VolatileStorage.prototype.removeItem = function (key) {
        this.data.delete(key);
    };
    VolatileStorage.prototype.clear = function () {
        this.data.clear();
    };
    return VolatileStorage;
}());
var storage = isLocalStorageAvailable() ? localStorage : new VolatileStorage();
var Keys;
(function (Keys) {
    Keys["BenchmarkResult"] = "benchmarkResult";
    Keys["History"] = "history";
    Keys["HistoryLegacy"] = "measuringHistory";
    Keys["HistoryDidMigrate"] = "didMigrate";
    Keys["ClientID"] = "clientId";
})(Keys || (Keys = {}));
function fullKey(k) {
    return prefix + k;
}
function clearStorage() {
    storage.clear();
}
exports.clearStorage = clearStorage;
function getBenchmarkResult(logger) {
    var dataStr = storage.getItem(fullKey(Keys.BenchmarkResult));
    if (dataStr == null) {
        return null;
    }
    try {
        var data = JSON.parse(dataStr);
        if (typeof data !== "object") {
            return null;
        }
        ;
        if (typeof data.timestamp !== "number") {
            return null;
        }
        ;
        if (typeof data.result1 !== "number") {
            return null;
        }
        ;
        if (typeof data.result2 !== "number" && data.result2 !== null) {
            return null;
        }
        ;
        return data;
    }
    catch (err) {
        logger.error(err, "Error parsing benchmark result from localStorage");
        return null;
    }
}
exports.getBenchmarkResult = getBenchmarkResult;
function setBenchmarkResult(data) {
    storage.setItem(fullKey(Keys.BenchmarkResult), JSON.stringify(data));
}
exports.setBenchmarkResult = setBenchmarkResult;
function removeBenchmarkResult() {
    storage.removeItem(fullKey(Keys.BenchmarkResult));
}
exports.removeBenchmarkResult = removeBenchmarkResult;
function getHistory() {
    return storage.getItem(fullKey(Keys.History));
}
exports.getHistory = getHistory;
function setHistory(data) {
    storage.setItem(fullKey(Keys.History), data);
}
exports.setHistory = setHistory;
function removeHistory() {
    storage.removeItem(fullKey(Keys.History));
}
exports.removeHistory = removeHistory;
function getHistoryLegacy() {
    return storage.getItem(fullKey(Keys.HistoryLegacy));
}
exports.getHistoryLegacy = getHistoryLegacy;
function setHistoryLegacy(data) {
    return storage.setItem(fullKey(Keys.HistoryLegacy), data);
}
exports.setHistoryLegacy = setHistoryLegacy;
function getHistoryDidMigrate() {
    var retVal = storage.getItem(fullKey(Keys.HistoryDidMigrate));
    return retVal === "true";
}
exports.getHistoryDidMigrate = getHistoryDidMigrate;
function setHistoryDidMigrate() {
    var data = "true";
    storage.setItem(fullKey(Keys.HistoryDidMigrate), data);
}
exports.setHistoryDidMigrate = setHistoryDidMigrate;
function getClientId() {
    return storage.getItem(fullKey(Keys.ClientID));
}
exports.getClientId = getClientId;
function setClientId(data) {
    storage.setItem(fullKey(Keys.ClientID), data);
}
exports.setClientId = setClientId;
function removeClientId() {
    storage.removeItem(fullKey(Keys.ClientID));
}
exports.removeClientId = removeClientId;
function isLocalStorageAvailable() {
    try {
        var storage_1 = window['localStorage'];
        var x = '__storage_test__';
        storage_1.setItem(x, x);
        storage_1.removeItem(x);
        return true;
    }
    catch (e) {
        return false;
    }
}
//# sourceMappingURL=localStorage.js.map